/* eslint-disable */
import session from './session';

export default {
    getLockerList(filter) {
        return session.get(`device/${filter}`);
    },
    getLocker(id) {
        return session.get(`device/${id}/`);
    },
    createLocker(data) {
        return session.post(`device/`, data);
    },
    updateLocker(id, data) {
        return session.patch(`device/${id}/`, data );
    },
    deleteLocker(id) {
        return session.delete(`device/${id}/`);
    },
};